<mat-form-field appearance="outline" class="location-selector">

  <mat-label>Instalación</mat-label>

  <mat-select
    [value]="selected"
    (selectionChange)="select($event.value, false)"
    [compareWith]="byClientId"
    [disabled]="isDisabled"
    [attr.data-mode]="isGlobalView"
    panelClass="location-selector-panel"
  >

    <!-- UN SOLO TRIGGER -->
    <mat-select-trigger>

      <!-- GLOBAL MODE -->
      <ng-container *ngIf="isGlobalMode; else normalTrigger">
        <div class="trigger-content global">
          <mat-icon>public</mat-icon>
          <span class="text">Global</span>
        </div>
      </ng-container>

      <!-- NORMAL MODE -->
      <ng-template #normalTrigger>
        <div *ngIf="!selected && isSelectionRequired" class="trigger-content offline">
          <mat-icon class="status-icon">location_off</mat-icon>
          <span class="text">Selecciona una instalacion</span>
        </div>

        <div class="trigger-content"
             *ngIf="selected || !isSelectionRequired"
             [class.online]="selected?.online"
             [class.offline]="!selected?.online">

          <mat-icon class="status-icon">
            {{ selected?.online ? 'link' : 'link_off' }}
          </mat-icon>

          <span class="text">
            {{ selected?.locationsId }}-{{ selected?.locationCode }}
          </span>

        </div>
      </ng-template>

    </mat-select-trigger>

    <!-- Options -->
    <mat-option
      *ngFor="let loc of locations"
      [value]="loc"
    >
      <div class="option-content"
           [class.online]="loc.online"
           [class.offline]="!loc.online">

        <mat-icon class="status-icon">
          {{ loc.online ? 'link' : 'link_off' }}
        </mat-icon>

        <span class="option-text">
          {{ loc.locationsId }}-{{ loc.locationCode }}
        </span>

      </div>
    </mat-option>

  </mat-select>

</mat-form-field>
